export enum NotificationType {
  Test = 'Test',
  Invite = 'Invite',
  InviteReturn = 'InviteReturn',
  InviteChanged = 'InviteChanged',
  WaitlistOpened = 'WaitlistOpened',
  WaitlistClosed = 'WaitlistClosed',
  InviteExpired = 'InviteExpired',
  DemeritReceived = 'DemeritReceived',
  PaymentSubscriptionCancelled = 'PaymentSubscriptionCancelled',
  PaymentFailed = 'PaymentFailed',
  ReviewLastWorkout = 'ReviewLastWorkout',
  StudioCheckin = 'StudioCheckin',
  HomeCheckin = 'HomeCheckin',
}

export enum NotificationSeverity {
  Urgent = 'Urgent',
  Warning = 'Warning',
  Info = 'Info',
}

export interface IInviteData {
  bookingReference?: string;
  from?: string;
  day: number;
}

export interface IInviteReturnData extends IInviteData {
  state: string;
}

export interface INotificationData {
  title: string;
  message: string;
  type: NotificationType;
  severity: NotificationSeverity;
  data: IInviteData | IInviteReturnData | any | undefined;
}

export interface IUserSubstitutions {
  fullname: string;
  firstname: string;
  nickname: string;
}

export interface IDateSubstitutions {
  yearMonthDay: string;
  hourAndMinute: string;
  localTimeHourAndMinute: string;
  msecSinceEpoch: number;
  formattedDateTime: string;
}

export interface IBaseNotificationSubstitutions {
  notificationReference: string;
  notificationBaseLink: string;
}

// substitution objects must be flat (no nested objects) in send grid
export interface IWaitListSubstitutions extends IBaseNotificationSubstitutions {
  avatarUrl: string;
  bookingYearMonthDay: string;
  bookingHourAndMinute: string;
  bookingFormattedDateTime: string;
}

export interface IDemeritSubstitutions extends IBaseNotificationSubstitutions {
  avatarUrl: string;
  bookingYearMonthDay: string;
  bookingHourAndMinute: string;
  bookingFormattedDateTime: string;
  firstname: string;
}

// substitution objects must be flat (no nested objects) in send grid
export interface IInvitationSubstitutions extends IBaseNotificationSubstitutions {
  inviterFullname: string;
  inviterFirstname: string;
  inviterAvatarUrl: string;
  inviteeFullname: string;
  inviteeFirstname: string;
  inviteeAvatarUrl: string;
  bookingYearMonthDay: string;
  bookingHourAndMinute: string;
  bookingFormattedDateTime: string;
  bookingReference: string;
}

export interface IPaymentCancelledSubstitutions extends IBaseNotificationSubstitutions {
  firstname: string;
  avatarUrl: string;
  nextBillingPeriodDate: string;
  currentPlan: string;
  interval: string;
}

export interface IAccountCancelledSubstitutions extends IBaseNotificationSubstitutions {
  firstname: string;
  avatarUrl: string;
  currentPlan: string;
  amount: string;
  hostedInvoiceUrl: string;
}

export interface IPlanChangedSubstitutions extends IBaseNotificationSubstitutions {
  firstname: string;
  avatarUrl: string;
  currentPlan: string;
  oldPlan: string;
  amount: string;
  interval: string;
  accessTimes: string;
}

export class UserNotification implements INotificationData {
  public id: string;

  public readonly created: number;

  public readonly title: string;

  public readonly message: string;

  public readonly type: NotificationType;

  public readonly severity: NotificationSeverity;

  public read: boolean;

  public readonly data: IInviteData | IInviteReturnData | any | undefined;
}
